import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/leadfeedbacktypes_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleLeadfeedbacktype } from "../../shared/hooks/UseLeadfeedbacktype";
const ViewLeadfeedbacktype = ({ match }) => {
  const [data] = useSingleLeadfeedbacktype(match.params.id);
  const { loading, leadfeedbacktype } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          leadfeedbacktype && (
            <SingleView
              data={leadfeedbacktype}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={leadfeedbacktype._id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewLeadfeedbacktype;
          